/**
 * Is every cart item available in the country? An item is not available when
 * its `regions_excluded` has the country, or its `regions_included` is not
 * empty and does not have it. Pure: the items are Redux basket objects, so it
 * must not write to them.
 *
 * @param   {Object[]} items       The cart items.
 * @param   {string}   countryCode ISO 3166-1 alpha-2
 * @returns {boolean}              False when any item is not available.
 */
export default function showRegionAvailability(items, countryCode) {
  return !items.some((item) => {
    const includedCodes = item.regions_included || [];
    const excludedCodes = item.regions_excluded || [];

    return (Array.isArray(excludedCodes) && excludedCodes.includes(countryCode))
      || (Array.isArray(includedCodes)
        && includedCodes.length > 0 && !includedCodes.includes(countryCode));
  });
}
